// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-mechanisms/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springMechanismsEN: PageEntry = {
  id: "post.federmechanismen",
  locale: "en",
  slug: "spring-mechanisms",
  seo: {
    title: "Glossary: Spring mechanisms explained simply | Dietz GmbH",
    description: "Spring mechanisms describe the different types and applications of springs in technical systems. There are various spring mechanisms, including compression springs, tension springs",
  },
  type: "post",
  h1: "Glossary: Spring mechanisms explained simply",
  intro: "Spring mechanisms describe the different types and applications of springs in technical systems. There are various spring mechanisms, including compression springs, tension springs, torsion springs and leaf springs. Each mechanism has specific properties that are suitable for certain applications. For example, compression springs are used in suspension systems, while extension springs are used in locking mechanisms. Understanding the different spring mechanisms enables engineers to select and design the most suitable spring for each application.",
  blocks: [

  ],
};
